// Format characters (Unicode category Cf: zero-width space, joiners, bidi
// marks) render as nothing, so a value made only of them and whitespace shows
// as much as an empty one. The API stores such editor copy as unset and the
// web treats it as absent; both read this one rule so they cannot disagree on
// what the other will publish.
const FORMAT_CHARACTERS = /\p{Cf}/gu;
export function isBlank(value) {
    return value.replace(FORMAT_CHARACTERS, '').trim() === '';
}
//# sourceMappingURL=visible-text.js.map